<template>
  <div class="service-upserter__container">
    <icon-view
      id="service-upserter__icon"
      icon="fas fa-plus mb-1"
      icon-background="#fff"
      icon-color="#FF7058"
      title="Añadir/Actualizar Servicio"
    />

    <div class="service-upserter-action__container">
      <p>Seleccione para continuar</p>
      <div class="service-upserter-action-options__container">
        <span
          v-for="action in actionOptions"
          :key="action.id"
          class="service-upserter-action-option__container"
        >
          <input
            :id="action.id"
            v-model="selectedAction"
            :name="action.id"
            type="radio"
            :value="action.value"
          />
          <label class="service-upserter-action__text" :for="action.id">
            <i :class="action.icon" />
            {{ action.label }}
          </label>
        </span>
      </div>

      <validation-observer ref="serviceActionForm">
        <div v-if="showInputs" class="row my-4">
          <div class="col-6 col-lg-3">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                v-model="model.serviceType"
                :custom-error-msg="'El tipo de servicio es requerido.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Tipo de Servicio:"
                :options="serviceTypeOptions"
                placeholder="Seleccione"
                @input="handleChangeServiceType"
              />
            </validation-provider>
          </div>

          <div v-if="showEvaluationType" class="col-6 col-lg-3">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                v-model="model.evaluationType"
                :custom-error-msg="'El tipo de evaluación es requerido.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Tipo de Evaluación:"
                :options="evaluationTypeOptions"
                placeholder="Seleccione"
                @input="handleChangeEvaluationType"
              />
            </validation-provider>
          </div>

          <div class="col-6 col-lg-3">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                v-model="model.service"
                :custom-error-msg="'El servicio es requerido.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Servicio/Actividad:"
                :options="serviceOptionsFiltered"
                placeholder="Seleccione"
                @input="handleChangeService"
              />
            </validation-provider>
          </div>

          <div v-if="showModality" class="col-6 col-lg-3">
            <validation-provider
              v-slot="{ errors }"
              :rules="isModalityRequired ? 'required' : ''"
            >
              <custom-drop-down
                v-model="model.modality"
                :custom-error-msg="'La modalidad es requerida.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Modalidad:"
                :options="modalityOptions"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>

          <div v-if="showDuration" class="col-6 col-lg-3">
            <validation-provider
              v-slot="{ errors }"
              :rules="isDurationRequired ? 'required' : ''"
            >
              <custom-drop-down
                v-model="model.duration"
                :custom-error-msg="'La duración es requerida.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Duración:"
                :options="durationOptionsFiltered"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>

          <div v-if="showSiteType" class="col-6 col-lg-3">
            <custom-drop-down
              v-model="model.siteType"
              fieldkey="id"
              fieldname="name"
              label="Tipo de Lugar:"
              :options="locationTypeOptions"
              placeholder="Seleccione"
              @input="handleChangeSiteType"
            />
          </div>

          <div v-if="showSchoolType" class="col-6 col-lg-3">
            <custom-drop-down
              v-model="model.schoolType"
              fieldkey="id"
              fieldname="name"
              label="Tipo de Escuela:"
              :options="schoolTypeOptions"
              placeholder="Seleccione"
            />
          </div>

          <div v-if="showMunicipality" class="col-6 col-lg-3">
            <custom-drop-down
              v-model="model.municipality"
              fieldkey="id"
              fieldname="name"
              label="Municipio:"
              :options="municipalityOptionsFiltered"
              placeholder="Seleccione"
            />
          </div>

          <div class="col-6 col-lg-3">
            <validation-provider v-slot="{ errors }" rules="min_value:0">
              <custom-input
                ref="priceInput"
                v-model="model.price"
                class="custom-input__extended"
                custom-error-msg="El costo deber ser igual o mayor a cero."
                :error="errors[0]"
                label="Costo(s):"
                mask-type="Money"
                prepend-icon="fas fa-plus"
                :prepend-icon-left="true"
                prepend-icon-type="success"
              />
            </validation-provider>
          </div>
        </div>
        <div v-else-if="inUpdateAction" class="row my-4">
          <div class="col-6 col-lg-3">
            <validation-provider v-slot="{ errors }" rules="min_value:0">
              <custom-input
                ref="priceInput"
                v-model="model.price"
                class="custom-input__extended"
                custom-error-msg="El costo deber ser igual o mayor a cero."
                :error="errors[0]"
                label="Costo(s):"
                mask-type="Money"
                prepend-icon="fas fa-plus"
                :prepend-icon-left="true"
                prepend-icon-type="success"
              />
            </validation-provider>
          </div>
        </div>
      </validation-observer>

      <div class="d-flex justify-content-end">
        <action-button
          i="fas fa-times-circle"
          text="Cerrar"
          variant="outline-danger"
          @click="$emit('close')"
        />
        <div class="ml-3">
          <action-button
            v-if="inAddAction"
            i="fas fa-file-plus"
            text="Añadir"
            variant="success"
            @click="handleAdd"
          />
          <action-button
            v-if="inUpdateAction"
            i="fas fa-sync-alt"
            text="Actualizar"
            variant="success"
            @click="handleUpdate"
          />
          <action-button
            v-if="inRemoveAction"
            i="fas fa-minus-circle"
            text="Eliminar"
            variant="danger"
            @click="$emit('remove')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconView from 'icon-view';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';

import DisciplineTypeCode from '@/utils/constants/disciplineTypeCode.js';
import BillingServiceTypes from '@/utils/constants/billingServiceTypes.js';
import Durations from '@/utils/constants/durations.js';
import Municipalities from '@/utils/constants/municipalities.js';
import locationTypes from '@/utils/constants/locationTypes.js';

const ADD_VALUE = 'add';
const UPDATE_VALUE = 'edit';
const REMOVE_VALUE = 'remove';

const ACTION_OPTIONS = [
  {
    id: 'action-btn-add',
    icon: 'fas fa-file-plus text-green',
    label: 'Añadir',
    name: 'Añadir',
    value: ADD_VALUE,
  },
  {
    id: 'action-btn-edit',
    icon: 'fas fa-edit text-green',
    label: 'Editar',
    name: 'Editar',
    value: UPDATE_VALUE,
  },
  {
    id: 'action-btn-delete',
    icon: 'fas fa-minus-circle color-primary-3',
    label: 'Eliminar',
    name: 'Eliminar',
    value: REMOVE_VALUE,
  },
];

export default {
  name: 'ProviderServiceManager',
  components: {
    IconView,
    CustomInput,
    ActionButton,
    CustomDropDown,
  },
  props: {
    serviceOptions: {
      type: Array,
      default: () => [],
    },
    serviceTypeOptions: {
      type: Array,
      default: () => [],
    },
    evaluationTypeOptions: {
      type: Array,
      default: () => [],
    },
    locationTypeOptions: {
      type: Array,
      default: () => [],
    },
    schoolTypeOptions: {
      type: Array,
      default: () => [],
    },
    municipalityOptions: {
      type: Array,
      default: () => [],
    },
    modalityOptions: {
      type: Array,
      default: () => [],
    },
    durationOptions: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    selectedAction: null,
    model: {
      serviceType: null,
      service: null,
      evaluationType: null,
      siteType: null,
      schoolType: null,
      municipality: null,
      modality: null,
      duration: null,
      price: 0,
    },
    actionOptions: ACTION_OPTIONS,
  }),
  computed: {
    showInputs() {
      return this.inAddAction;
    },
    inAddAction() {
      return this.selectedAction == ADD_VALUE;
    },
    inUpdateAction() {
      return this.selectedAction == UPDATE_VALUE;
    },
    inRemoveAction() {
      return this.selectedAction == REMOVE_VALUE;
    },
    showEvaluationType() {
      return (
        this.model.serviceType?.id == BillingServiceTypes.EvaluacionAdicional
      );
    },
    showModality() {
      return (
        this.model.serviceType?.id == BillingServiceTypes.Terapia &&
        this.model.service?.id != DisciplineTypeCode.Admision &&
        this.model.service?.id != DisciplineTypeCode.DiscusionDePlan
      );
    },
    showDuration() {
      const availableServiceTypes = [
        BillingServiceTypes.Terapia,
        BillingServiceTypes.Consultoria,
      ];

      return (
        availableServiceTypes.includes(this.model.serviceType?.id) &&
        this.model.service?.id != DisciplineTypeCode.Admision &&
        this.model.service?.id != DisciplineTypeCode.DiscusionDePlan
      );
    },
    showSiteType() {
      return (
        this.model.serviceType?.id == BillingServiceTypes.Terapia &&
        this.model.service?.id != DisciplineTypeCode.Admision &&
        this.model.service?.id != DisciplineTypeCode.DiscusionDePlan
      );
    },
    showSchoolType() {
      return this.model.siteType?.id === locationTypes.Escuela;
    },
    showMunicipality() {
      return (
        this.model.serviceType?.id != BillingServiceTypes.Consultoria &&
        this.model.service?.id != DisciplineTypeCode.Admision &&
        this.model.service?.id != DisciplineTypeCode.DiscusionDePlan
      );
    },
    isDurationRequired() {
      return this.showDuration && this.selectedAction != UPDATE_VALUE;
    },
    isModalityRequired() {
      return this.showModality && this.selectedAction != UPDATE_VALUE;
    },
    isSchoolTypeRequired() {
      return this.showSchoolType && this.selectedAction != UPDATE_VALUE;
    },
    serviceOptionsFiltered() {
      if (this.model.serviceType?.id == BillingServiceTypes.Consultoria) {
        return this.serviceOptions;
      }

      return this.serviceOptions;
    },
    payloadEvent() {
      return {
        serviceId: this.model.service.id,
        serviceName: this.model.service.name,
        serviceTypeId: this.model.serviceType.id,
        evaluationTypeId: this.model.evaluationType?.id,
        siteTypeId: this.model.siteType?.id,
        schoolTypeId: this.model.schoolType?.id,
        municipalityId: this.model.municipality?.id,
        modalityId: this.model.modality?.id,
        durationId: this.model.duration?.id,
        price: this.model.price,
      };
    },
    durationOptionsFiltered() {
      const serviceTypes = [
        BillingServiceTypes.Terapia,
        BillingServiceTypes.Consultoria,
      ];

      if (!serviceTypes.includes(this.model.serviceType?.id)) return [];

      const notRestrictedServices = [
        DisciplineTypeCode.ConsultoriaABA,
        DisciplineTypeCode.TerapiaEducativa,
      ];

      if (notRestrictedServices.includes(this.model.service?.id)) {
        return this.durationOptions;
      }

      const excludedDurations = [
        Durations.MIN240,
        Durations.MIN280,
        Durations.MIN300,
        Durations.MIN360,
        Durations.MIN420,
      ];
      return this.durationOptions.filter(
        (option) => !excludedDurations.includes(option.id)
      );
    },
    municipalityOptionsFiltered() {
      if (this.model.serviceType?.id == BillingServiceTypes.Consultoria) {
        return this.municipalityOptions;
      }

      const AvailableMunicipalities = [
        Municipalities.Culebra,
        Municipalities.Vieques,
      ];

      return this.municipalityOptions.filter((option) =>
        AvailableMunicipalities.includes(option.id)
      );
    },
  },
  watch: {
    async selectedAction(newValue) {
      await this.clearForm();

      let actionsAvailablesToBulkAction = [UPDATE_VALUE, REMOVE_VALUE];

      this.$emit(
        'toggle-bulk-action',
        actionsAvailablesToBulkAction.includes(newValue)
      );
      this.$emit('toggle-search', newValue != ADD_VALUE);
      this.$emit('change-action');
    },
  },
  methods: {
    async clearForm() {
      this.model.serviceType = null;
      await this.handleChangeServiceType();
    },
    async handleChangeServiceType(payload) {
      this.model.evaluationType = null;
      this.handleChangeEvaluationType();

      this.$emit('service-type-selected', payload);
    },
    async handleChangeEvaluationType() {
      this.model.service = null;
      this.handleChangeService();
    },
    async handleChangeService() {
      await this.$refs.serviceActionForm.reset();
      if (this.inRemoveAction) return;

      this.model.siteType = null;
      this.model.schoolType = null;
      this.model.municipality = null;
      this.model.modality = null;
      this.model.duration = null;
      this.$refs.priceInput.moneyValue = 0;
    },
    async handleChangeSiteType() {
      await this.$refs.serviceActionForm.reset();
      if (this.inRemoveAction) return;

      this.model.schoolType = null;
      this.$refs.priceInput.moneyValue = 0;
    },
    async handleAdd() {
      const isValid = await this.$refs.serviceActionForm.validate();
      if (!isValid) return;

      this.$emit('add', this.payloadEvent);
    },
    async handleUpdate() {
      this.$emit('update', {
        price: this.model.price,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

.service-upserter__container {
  background-color: #f4f6f3;
  padding: 25px;
}

#service-upserter__icon ::v-deep em {
  font-size: 18px;
  margin: 0 !important;
}

.service-upserter-action__container {
  margin-top: 15px;
}

.service-upserter-action-options__container {
  background-color: white;
  border: 1px solid #e9e9e9;
  padding: 5px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 400px;
}

.service-upserter-action-option__container {
  display: flex;
  align-items: center;
}

.service-upserter-action-option__container input[type='radio'] {
  display: none;
}

.service-upserter-action-option__container
  input[type='radio']
  + .service-upserter-action__text:before {
  content: '';
  display: inline-block;
  width: 20px;
  height: 20px;
  padding: 3px;
  background-clip: content-box;
  border: 1px solid #e6e6e6;
  background-color: transparent;
  border-radius: 50%;
}

.service-upserter-action-option__container
  input[type='radio']:checked
  + .service-upserter-action__text:before {
  background-color: #2db782;
}

.service-upserter-action__text {
  display: flex;
  align-items: center;
  margin: 0 10px;
}

.service-upserter-action__text i {
  margin: 0 5px;
}

::v-deep .custom-input__extended {
  .input-group {
    .input-group-text {
      background: map-get($colors, 'green');
      color: map-get($colors, 'white');
    }
  }
}
</style>
